import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import shallowequal from "shallowequal";
import { Link } from "react-router-dom";
import { MyIcon, IMG_DEFAULT } from "../../common/baseConfig";
import { List, AutoComplete, Input, message } from "antd";
import Tabs from "./Tabs";
import NoneData from "../common/NoneData";
export class CouseSelectList extends Component {
  state = {
    selectIndex: 0, //0-课程包 1-课程
    firstIndex: 0, //第一级分类
    secondIndex: 0, //第二级分类
    thirdIndex: 0, //第三级分类
    categoryIndex: 0, //课程分类 课程包没有该分类
    provinceIndex: 0,//省份
    secondList: [],
    thirdList: [],
    curPage: 1,
    searchWord: "",
  }
  static propTypes = {
    course: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    let pathname = this.props.history.location.pathname;
    let pathArr = pathname.substring(pathname.lastIndexOf('/') + 1, pathname.length).split('-');
    //获取省份数据
    this.props.actions.fetchGetProvinces({type: 1});
    if (pathArr.length === 3) {
      //课程包
      this.setState({
        selectIndex: 0,
        firstIndex: parseInt(pathArr[0], 10),
        secondIndex: parseInt(pathArr[1], 10),
        thirdIndex: parseInt(pathArr[2], 10),
      }, () => {
        this.onLoadSelecList();
      })
    } else {
      //课程
      this.setState({
        selectIndex: 1,
        firstIndex: parseInt(pathArr[0], 10),
        secondIndex: parseInt(pathArr[1], 10),
        thirdIndex: parseInt(pathArr[2], 10),
        categoryIndex: parseInt(pathArr[3], 10)
      }, () => {
        this.onLoadSelecList();
      })
    }
  }
  componentDidMount() {
    const { selectIndex } = this.state;
    this.props.actions.fetchGetAllDisciplineInfo({
      Type: selectIndex === 0 ? 1 : 0,
    });
    this.props.actions.fetchGetDisciplineInfoByCourse({
      Type: selectIndex === 0 ? 1 : 0,
    })
  }
  componentDidUpdate(preProps, preState) {
    const { secondIndex, firstIndex, selectIndex, thirdIndex, categoryIndex } = this.state;
    if (!shallowequal(preState, this.state)) {
      console.log('DidUpdate');
      //state前后无变化无需更新否则堆栈溢出
      this.onLoadSelecList();
      this.updateRouter([selectIndex, firstIndex, secondIndex, thirdIndex, categoryIndex]);
    }
  }
  updateRouter(pathArr) {
    if (pathArr[0] === 0) {
      this.props.history.replace(
        `/select/0/${pathArr[1]}-${pathArr[2]}-${pathArr[3]}`
      )
    } else {
      this.props.history.replace(
        `/select/1/${pathArr[1]}-${pathArr[2]}-${pathArr[3]}-${pathArr[4]}`
      )
    }
  }
  //课程 课程包切换
  onTabsChange(selectIndex) {
    this.setState({
      selectIndex,
      firstIndex: 0, //第一级分类
      secondIndex: 0, //第二级分类
      thirdIndex: 0, //第三级分类
      categoryIndex: 0, //课程分类 课程包没有该分类
      secondList: [],
      thirdList: [],
      curPage: 1,
    }, () => {
      this.props.actions.fetchGetAllDisciplineInfo({
        Type: selectIndex === 0 ? 1 : 0,
      });
      this.props.actions.fetchGetDisciplineInfoByCourse({
        Type: selectIndex === 0 ? 1 : 0,
      })
      this.props.actions.fetchGetProvinces({type: selectIndex === 0 ? 1 : 0});
    })
  }
  getDisciplineID() {
    const { firstIndex, secondIndex, thirdIndex, categoryIndex, provinceIndex } = this.state;
    let discipline_ID = 0;
    if (thirdIndex === 0) {
      discipline_ID = secondIndex;
      if (secondIndex === 0) {
        discipline_ID = firstIndex;
        if (firstIndex === 0) {
          discipline_ID = 0;
        }
      }
    } else {
      discipline_ID = thirdIndex;
    }
    return { Discipline_ID: discipline_ID, TeachingMethod: categoryIndex, Province_ID: provinceIndex };

  }
  onLoadSelecList() {
    let obj = this.getDisciplineID();
    if (this.state.selectIndex === 0) {
      //课程包加载
      this.props.actions.fetchGetStuCoursePackList({
        PageSize: 12,
        PageIndex: this.state.curPage,
        PageStatus: 1,
        ...obj,
      });
    } else {
      //课程加载
      this.props.actions.fetchGetStuCourseList({
        PageSize: 12,
        PageIndex: this.state.curPage,
        PageStatus: 1,
        ...obj,
      });
    }
  }
  //一级分类
  onFirstChange(firstIndex) {
    const { fetchGetAllSecondListByIDs } = this.props.course;
    this.setState({
      firstIndex,
      secondIndex: 0,
      thirdIndex: 0,
      secondList: firstIndex === 0 ? [] : fetchGetAllSecondListByIDs[firstIndex],
      thirdList: [],
      curPage: 1,
    });
  }
  //二级学科
  onSecondChange(secondIndex) {
    const { fetchGetAllThirdListByIDs } = this.props.course;
    this.setState({
      secondIndex: secondIndex,
      thirdIndex: 0,
      thirdList: secondIndex === 0 ? [] : fetchGetAllThirdListByIDs[secondIndex],
      curPage: 1,
    })
  }
  //三级学科
  onThirdChange(thirdIndex) {
    this.setState({
      thirdIndex,
      curPage: 1,
    });
  }
  //课程分类
  onCategoryChange(categoryIndex) {
    this.setState({
      categoryIndex,
      curPage: 1,
    });
  }
  renderItem(item) {
    return (
      <Link
        key={item.ID}
        className="courseSelectList-inner-item"
        to={this.state.selectIndex === 0 ? `/coursepack/detail/${item.ID}` : `/course/detail/${item.ID}`}
      >
        <img src={item.CoverPath ? item.CoverPath + '?x-oss-process=image/resize,m_fixed,h_158,w_283' : IMG_DEFAULT} alt='' />
        <h2>
          {item.Name}
        </h2>
        <p>
          <span>
            {item.PreferentialPrice === 0 ? '免费' : '¥' + item.PreferentialPrice.toFixed(2)}{' '}
            {item.IsShiT > 0 ? '可试学' : ''}
          </span>
          <span>
            <MyIcon type="iconrenshu" /> {item.BuyBase + (item.BuyCount || 0)}
          </span>
        </p>
      </Link>
    );
  }
  searchCourse() {
    const keyWord = this.state.searchWord;
    if (keyWord.trim() === "") {
      message.warn("搜索关键字不能为空");
      return;
    }
    this.props.history.push(`/search?key=${encodeURI(keyWord)}`);
  }
  onChangeSearch(value) {
    this.setState({ searchWord: value })
    // this.state.searchWord = value;
  }
  onProvinceClick(index) {
    this.setState({
      provinceIndex: index,
      curPage: 1,
    }, () => {
      this.onLoadSelecList()
    })
  }
  render() {
    let {
      selectIndex,
      firstIndex,
      secondIndex,
      thirdIndex,
      provinceIndex,
      secondList,
      thirdList,
      categoryIndex,
      curPage } = this.state;
    const dataSource = JSON.parse(localStorage.getItem("searchRecord")) || [];
    const {
      fetchGetAllDisciplineInfoSuccess,
      fetchGetAllThirdListByIDs,
      fetchGetAllSecondListByIDs,
      DefaultCategoryListData,
      fetchGetStuCourseListSuccess,
      fetchGetStuCourseListPending,
      fetchGetStuCourseListTotal,
      fetchGetStuCoursePackListSuccess,
      fetchGetStuCoursePackListPending,
      fetchGetStuCoursePackListTotal,
      fetchGetDisciplineInfoByCourseSuccess,
    } = this.props.course;
    let {
      fetchGetProvincesSuccess
    } = this.props.center;
    let listData, listTotal, listPending;
    if (selectIndex === 0) {
      listData = fetchGetStuCoursePackListSuccess;
      listTotal = fetchGetStuCoursePackListTotal;
      listPending = fetchGetStuCoursePackListPending;
    } else {
      listData = fetchGetStuCourseListSuccess;
      listTotal = fetchGetStuCourseListTotal;
      listPending = fetchGetStuCourseListPending;
    }
    if (firstIndex !== 0 && fetchGetAllSecondListByIDs) {
      secondList = fetchGetAllSecondListByIDs[firstIndex];
    }
    if (secondIndex !== 0 && fetchGetAllThirdListByIDs) {
      thirdList = fetchGetAllThirdListByIDs[secondIndex];
    }
    return (
      <div className="course-couse-select-list">
        <div className="banner">
          <h1>
            <p>选课中心</p>
            <div className="searchInp">
              <AutoComplete
                className="search_input"
                dropdownClassName="search_input_dropdown"
                dropdownMatchSelectWidth={false}
                dropdownStyle={{ width: 455 }}
                size="large"
                style={{ width: '100%' }}
                dataSource={dataSource}
                onChange={this.onChangeSearch.bind(this)}
                placeholder="输入搜索内容"
              >
                <Input suffix={<div onClick={() => this.searchCourse()} className='search_icon_wrap'>
                  <div className='search_icon'></div>
                </div>} />
              </AutoComplete>
            </div>
          </h1>

        </div>
        <div className="tabs">
          <Tabs
            {...this.props}
            cancelMatchRouter={true}
            specialTabs="select"
            tabs={[
              { ID: 0, Name: "课程包" },
              { ID: 1, Name: "课程" }
            ]}
            onTabsChange={this.onTabsChange.bind(this)}
          />
        </div>
        {
          fetchGetAllDisciplineInfoSuccess && fetchGetAllDisciplineInfoSuccess.length > 0 &&
          <div className="subject">
            <p>一级学科:</p>
            <ul>
              {
                fetchGetAllDisciplineInfoSuccess.map(item => (
                  <li
                    key={item.ID}
                    className={`radio${firstIndex === item.ID ? ' active-radio' : ''}`}
                    onClick={this.onFirstChange.bind(this, item.ID)}
                  >
                    {item.Name}
                  </li>
                ))
              }
            </ul>
          </div>
        }
        {
          selectIndex === 1 && firstIndex === 0 && fetchGetDisciplineInfoByCourseSuccess && fetchGetDisciplineInfoByCourseSuccess.length > 0 &&
          <div className="subject-nav-row subject-nav-skills">
            <div className="subject-skills-box">
              <span className="hd l">学科专业:</span>
              <div className="bd">
                <ul>
                  <li className="subject-nav-item on">全部</li>
                  {fetchGetDisciplineInfoByCourseSuccess.map(item => (
                    <li
                      key={item.ID}
                      className="subject-nav-item"
                      onClick={() => {
                        if (item.CCID === 0) {
                          //二级
                          this.setState({
                            firstIndex: item.CID,
                            secondIndex: item.ID,
                          })
                        } else {
                          //三级
                          this.setState({
                            firstIndex: item.CCID,
                            secondIndex: item.CID,
                            thirdIndex: item.ID
                          })
                        }
                      }}
                    >
                      {item.Name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        }
        {
          secondList && secondList.length !== 0 && <div className="subject">
            <p>二级学科:</p>
            <ul>
              {secondList.map(item => (
                <li
                  key={item.ID}
                  className={`radio${secondIndex === item.ID ? ' active-radio' : ''}`}
                  onClick={this.onSecondChange.bind(this, item.ID)}
                >
                  {item.Name}
                </li>
              ))}
            </ul>
          </div>
        }
        {thirdList&& thirdList.length !== 0 && (
          <div className="subject">
            <p>三级学科:</p>
            <ul>
              {thirdList.map(item => (
                <li
                  key={item.ID}
                  className={`radio${thirdIndex === item.ID ? ' active-radio' : ''}`}
                  onClick={this.onThirdChange.bind(this, item.ID)}
                >
                  {item.Name}
                </li>
              ))}
            </ul>
          </div>
        )} 
        {
          fetchGetProvincesSuccess && fetchGetProvincesSuccess.length > 0 && <div className="subject">
            <p>省份选择:</p> 
            <ul>
              <li className={`radio${provinceIndex === 0 ? ' active-radio' : ''}`} onClick={this.onProvinceClick.bind(this, 0)}>全部</li>
              {
                fetchGetProvincesSuccess.map((item, index) => (
                  // No duplicate props allowed ==> remove  className="radio"
                  <li key={index} className={`radio${provinceIndex === item.ProvinceID ? ' active-radio' : ''}`} onClick={this.onProvinceClick.bind(this, item.ProvinceID)}>{item.ProvinceName}</li>
                ))
              }
            </ul>
          </div>
        }
        {
          selectIndex === 1 &&
          <div className="category">
            <ul>
              <li>课程分类:</li>
              {DefaultCategoryListData.map(item => (
                <li
                  key={item.key}
                  className={`radio${categoryIndex === item.key ? ' active-radio' : ''}`}
                  onClick={this.onCategoryChange.bind(this, item.key)}
                >
                  {item.Name}
                </li>
              ))}
            </ul>
          </div>
        }
        <div className="courseSelectList">
          {
            listData && listData.length > 0 ? (
              <div className="courseSelectList-inner">
                <List
                  itemLayout="horizontal"
                  size="large"
                  pagination={{
                    onChange: page => {
                      this.setState(
                        {
                          curPage: page,
                        },
                        // () => {
                        //   this.onLoadSelecList();
                        // },
                      );
                    },
                    current: curPage,
                    total: listTotal,
                    pageSize: 12,
                  }}
                  loading={listPending}
                  dataSource={listData}
                  renderItem={item => this.renderItem(item)}
                />
              </div>
            ) : (
                <div className="noneData">
                  <NoneData type={1} />
                </div>
              )}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    course: state.course,
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouseSelectList);



// WEBPACK FOOTER //
// ./src/features/course/CouseSelectList.js